export default __webpack_public_path__ + "static/media/co-pay-icon.eea97d66.svg";